import React from "react";
import "aos/dist/aos.css";

// Remplace ce chemin par l'image de ton choix dans ton dossier assets
import formationImg from "../../assets/formation.jpg";

const Formation = () => {
  return (
    <section className="mt-16 w-full py-12 bg-[#F9F8FF]" id="formation">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        {/* Image */}
        <div
          className="w-full md:w-1/2 flex justify-center"
          data-aos="fade-right"
        >
          <img
            src={formationImg}
            alt="Illustration Formation"
            className="w-full max-w-xl md:max-w-2xl rounded-xl shadow-lg"
            loading="lazy"
          />
        </div>
        {/* Texte principal */}
        <div className="mt-10 w-full md:w-1/2" data-aos="fade-left">
          <h2 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
            Formation et montée en compétences
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            <span className="font-semibold text-[#00df9a]">Decintech</span>{" "}
            propose des formations sur-mesure pour accompagner la montée en
            compétences de vos équipes dans les domaines du numérique, de la
            data, du développement logiciel et du marketing digital.
          </p>
          <ul className="space-y-2 text-base text-gray-800 mb-4">
            <li>
              <span className="font-semibold text-[#00df9a]">
                Formations techniques :
              </span>{" "}
              Python, R, SQL, JavaScript, frameworks web, cloud, big data, data
              science, machine learning, etc.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Marketing digital :
              </span>{" "}
              Stratégie digitale, gestion des réseaux sociaux, SEO, SEA,
              publicité en ligne (Google Ads, Facebook Ads), content marketing,
              analytics et e-réputation.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Ateliers pratiques :
              </span>{" "}
              Mise en situation réelle, projets concrets et exercices
              interactifs pour un apprentissage efficace.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Accompagnement personnalisé :
              </span>{" "}
              Coaching, mentoring et suivi post-formation pour garantir la mise
              en application des compétences acquises.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Formats flexibles :
              </span>{" "}
              Sessions en présentiel, à distance ou hybrides, adaptées à vos
              contraintes et à vos objectifs.
            </li>
          </ul>
          <p className="text-gray-600">
            Nos formateurs sont des experts passionnés, à l’écoute de vos
            besoins, pour faire de la formation un véritable levier de
            transformation et d’innovation.
          </p>
        </div>
      </div>
      {/* Section supplémentaire sous le bloc principal */}
      <div className="max-w-7xl mx-auto mt-12 px-4" data-aos="fade-up">
        <h3 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
          Domaines et technologies enseignés
        </h3>
        <ul className="list-disc pl-6 text-gray-800 space-y-2 mb-6">
          <li>
            <span className="font-semibold text-[#00df9a]">
              Data Science & Analyse de données :
            </span>{" "}
            Python, R, Pandas, NumPy, scikit-learn, Power BI, Tableau.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Développement web & mobile :
            </span>{" "}
            JavaScript, React, Node.js, HTML, CSS, APIs.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Cloud & Big Data :
            </span>{" "}
            AWS, Azure, Google Cloud, Hadoop, Spark, Docker.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Marketing digital :
            </span>{" "}
            Stratégie digitale, social media, référencement naturel (SEO),
            publicité en ligne (SEA), Google Analytics, campagnes emailing,
            content marketing.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Méthodologies Agiles :
            </span>{" "}
            Scrum, Kanban, gestion de projet collaboratif.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Cybersécurité :
            </span>{" "}
            Sensibilisation, bonnes pratiques, sécurité des applications et des
            données.
          </li>
        </ul>
        <p className="text-gray-700">
          Nos parcours sont conçus pour s’adapter à tous les niveaux, du
          débutant à l’expert, et garantir une progression rapide et durable.
        </p>
      </div>
    </section>
  );
};

export default Formation;
